import siteBrand from "@/store/modules/site-brand";
import siteBrandSearchUser from "@/store/modules/site-brand-search-user";
import user from "@/store/modules/user";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const DEBUG = "development" === process.env.NODE_ENV;
export default new Vuex.Store({
  modules: { siteBrand, user, siteBrandSearchUser },
  strict: DEBUG,
});
